import { Select } from '../../../../../../components/select/select';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useFormStore } from '../../../../../../store/use-form-store';
import { IdValue } from '../../../../../../types/props';
import { Container } from '../../../../../../components/container/container';
import { FormElementTypeType, FormHelperType } from '../../../../../../store/api/forms-api';
import { MdDeleteForever } from 'react-icons/md';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { ExtendableBlock } from '../../../../../../components/extendable-block/extendable-block';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { InlineInputs } from '../../../../../../components/inline-inputs/inline-inputs';
import { Divider } from '../../../../../../components/divider/divider';

const infoRecord: Record<FormHelperType, string> = {
  none: 'Нет',
  label: 'Текст сверху',
  placeholder: 'Плейсхолдер',
  sublabel: 'Подпись',
};

const typeLabelRecord: Record<FormElementTypeType, FormHelperType[]> = {
  'multi-select': ['none', 'label', 'placeholder'],
  select: ['none', 'label', 'placeholder'],
  input: ['none', 'label', 'placeholder'],
  checkbox: ['none', 'sublabel'],
  switch: ['none', 'sublabel'],
  datetime: ['none', 'label'],
  datetimeRange: ['none', 'label'],
};

const isSelectOrMultiSelect = (type?: FormElementTypeType) => {
  return type === 'select' || type === 'multi-select';
};

export const FormCreateModalHelper = () => {
  const { t } = useLang();
  const { newElement, handleUpdateNewElement } = useFormStore();

  const helperTypes: IdValue[] = typeLabelRecord[newElement?.type || 'input'].map((item) => ({
    id: item,
    value: t(infoRecord[item]),
  }));

  const handleChangeInfoType = (value: IdValue) => {
    const updatedElement = { ...newElement };

    if (!updatedElement.info) {
      updatedElement.info = {};
    }
    handleUpdateNewElement({
      info: { ...updatedElement.info, helper: value.id as FormHelperType },
    });
  };

  const handleChangeHelpText = (e: LangType) => {
    if (newElement) {
      if (!newElement.info) {
        newElement.info = {};
      }

      handleUpdateNewElement({ info: { ...newElement.info, helper_text: e } });
    }
  };

  const handleChangeOptionName = (index: number, value: LangType) => {
    const updatedElement = newElement;
    if (updatedElement && updatedElement.info?.options) {
      updatedElement.info.options[index] = value;
      handleUpdateNewElement(updatedElement);
    }
  };

  const handleDeleteOption = (index: number) => {
    const updatedElement = newElement;
    if (updatedElement && updatedElement.info?.options) {
      updatedElement.info.options.splice(index, 1);
      handleUpdateNewElement(updatedElement);
    }
  };

  const handleAddOption = () => {
    const updatedElement = newElement;
    if (updatedElement) {
      if (!updatedElement.info) {
        updatedElement.info = {};
      }
      if (!updatedElement.info.options) {
        updatedElement.info.options = [];
      }
      updatedElement.info.options.push({});
      handleUpdateNewElement(updatedElement);
    }
  };

  const options = newElement?.info?.options;
  const withCounter = newElement?.info?.counter;

  const handleCheckCounter = () => {
    const prevValue = newElement?.info?.counter;
    handleUpdateNewElement({
      info: {
        ...newElement?.info,
        counter: !prevValue,
      },
    });
  };

  const localisedHelperTypes = helperTypes.map((item) => ({
    ...item,
    value: t(item.value),
  }));

  const selectedHelperType = localisedHelperTypes.find(
    (item) => item.id === newElement?.info?.helper,
  );

  return (
    <>
      <Container label={t('Подсказка')}>
        <Select
          placeholder={t('Выберите подсказку')}
          options={localisedHelperTypes}
          onSelect={handleChangeInfoType}
          value={selectedHelperType || helperTypes[0]}
        />
        {newElement?.info?.helper !== 'none' && (
          <LangInput
            value={newElement?.info?.helper_text}
            onChange={handleChangeHelpText}
            placeholder={t('Текст подсказки')}
          />
        )}
      </Container>

      {isSelectOrMultiSelect(newElement?.type) && (
        <>
          <Divider />
          <Container label={t('Опции')}>
            <ExtendableBlock button={{ children: t('Добавить опции') }} onAdd={handleAddOption}>
              {options?.map((item, index) => (
                <InlineInputs key={index}>
                  <LangInput value={item} onChange={(e) => handleChangeOptionName(index, e)} />
                  <IconButton size="lg" variant="danger" onClick={() => handleDeleteOption(index)}>
                    <MdDeleteForever />
                  </IconButton>
                </InlineInputs>
              ))}
            </ExtendableBlock>

            <Container isHorizontal label={t('Со счетчиком')}>
              <Checkbox checked={withCounter} onClick={handleCheckCounter} />
            </Container>
          </Container>
        </>
      )}
    </>
  );
};
